import { getFormattedDateFns } from 'shared/helpers/locale';
import endOfDay from 'date-fns/endOfDay';

export const posted = (time, locale = 'ru') => {
  if (
    getFormattedDateFns(endOfDay(new Date(time)), 'yyyy-MM-dd') ===
    getFormattedDateFns(endOfDay(new Date()), 'yyyy-MM-dd')
  ) {
    return getFormattedDateFns(time, 'H:mm');
  }
  return getFormattedDateFns(time, 'MMMM d, yyyy', locale);
};

export const createdDate = (time, locale = 'ru') =>
  getFormattedDateFns(time, 'MMMM d, yyyy', locale);

export const shortCreatedDate = (time, locale = 'ru') => getFormattedDateFns(time, 'dd.MM', locale);

export const getFullDate = (time, locale = 'ru') =>
  getFormattedDateFns(time, 'H:mm, MMMM d, yyyy', locale);

export const getShotDate = (time, locale = 'ru') => getFormattedDateFns(time, 'dd-MM-yyyy', locale);



// WEBPACK FOOTER //
// ./src/shared/helpers/moment.js